module.exports = __webpack_public_path__ + "static/media/dropoff.84103900.svg";